
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/[[...slug]]",
      function () {
        return require("private-next-pages/_sites/[site]/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/[[...slug]]"])
      });
    }
  